// ============================================
// Creator State - Autofill & Search (Zustand 기반)
// ============================================

import { useCreatorStore } from '../../../stores/creatorStore.js';

// ============================================
// 자동채우기 상태
// ============================================

export const getAutofillTagsCache = () => useCreatorStore.getState().autofillTagsCache;

export function setAutofillTagsCache(tags) {
  useCreatorStore.getState().setAutofillTagsCache(tags);
}

// 전체 자동 생성 탭 상태
export const getFullGenSelectedGenres = () => useCreatorStore.getState().fullGenSelectedGenres;
export const getFullGenSelectedModelId = () => useCreatorStore.getState().fullGenSelectedModelId;

export function setFullGenSelectedGenres(genres) {
  useCreatorStore.getState().setFullGenSelectedGenres(genres);
}

export function setFullGenSelectedModelId(modelId) {
  useCreatorStore.getState().setFullGenSelectedModelId(modelId);
}

// 로딩 메시지 인터벌
export const getLoadingMessageInterval = () => useCreatorStore.getState().loadingMessageInterval;

export function setLoadingMessageInterval(interval) {
  useCreatorStore.getState().setLoadingMessageInterval(interval);
}

// ============================================
// 검색 상태
// ============================================

export const getSearchTimeout = () => useCreatorStore.getState().searchTimeout;

export function setSearchTimeout(timeout) {
  useCreatorStore.getState().setSearchTimeout(timeout);
}
